import type { ImgHTMLAttributes, ReactElement } from "react";
import { cn } from "@/lib/utils";

/** Hermes — the same character mark the landing page ships (landing-d6),
 *  served verbatim from public/brand. */
export function HermesLogo(
  props: ImgHTMLAttributes<HTMLImageElement>
): ReactElement {
  // eslint-disable-next-line @next/next/no-img-element
  return (
    <img
      src="/brand/hermes.png"
      width={16}
      height={16}
      alt=""
      aria-hidden
      {...props}
      className={cn("rounded-4", props.className)}
    />
  );
}
